import React from 'react';
import './ProjectGallery.css';
import { useState } from 'react';
import { UilTimesCircle } from '@iconscout/react-unicons';
import { UilPrevious } from '@iconscout/react-unicons';
import { UilStepForward } from '@iconscout/react-unicons';

const ProjectGallery = (projects) => {

    const [slideNumber, setSlideNumber] = useState(0)
    const [openModal, setOpenModal] = useState(false)

    const handleOpenModal = (index) => {
        setSlideNumber(index)
        setOpenModal(true)
    }

    // Close Modal
    const handleCloseModal = () => {
        setOpenModal(false)
    }

    // Previous Image
    const prevSlide = () => {
        slideNumber === 0
            ? setSlideNumber(projects.projects.documents.length - 1)
            : setSlideNumber(slideNumber - 1)
    }

    // Next Image  
    const nextSlide = () => {
        slideNumber + 1 === projects.projects.documents.length
            ? setSlideNumber(0)
            : setSlideNumber(slideNumber + 1)
    }


    return (
        <div className='container-fluid'>


            {openModal &&
                <div className='sliderWrap' >
                    <UilTimesCircle color='black' className='btnClose' onClick={handleCloseModal} />
                    <UilPrevious className='btnPrev' onClick={prevSlide} />
                    <UilStepForward className='btnNext' onClick={nextSlide} />
                    <div className='fullScreenImage'>
                        <img src={projects.projects.documents[slideNumber].fields.images.stringValue} alt='' />
                    </div>
                </div>

            }


            <div className='gallery row' >
                {
                    projects.projects.documents && projects.projects.documents.sort((a, b) => a.serial - b.serial).map((slide, index) => {

                        return (
                            <div
                                className='col-lg-4 col-md-6 '
                                key={index}
                                onClick={() => handleOpenModal(index)}
                            >
                                <figure class="gallery__link ">
                                    <img src={slide.fields.images.stringValue} alt='' width="100%" height="100%" className=' gallery__image' />
                                </figure>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    );
};

export default ProjectGallery;